module.exports = __webpack_public_path__ + "img/horizontal_4_3_7016.a48b81b7.png";